import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';
import { normalizeTelemetryRecord } from '../utils/telemetryRecordNormalizer';

const FIELD_LABELS = [
  { key: 'messageId', label: 'messageId' },
  { key: 'sequenceNumber', label: 'sequenceNumber' },
  { key: 'controllerTimestamp', label: 'Controller Timestamp' },
  { key: 'systemStateText', label: 'systemStateText' },
  { key: 'canopyStateText', label: 'canopyStateText' },
  { key: 'errorCount', label: 'errorCount' },
  { key: 'windSpeed3sAvg', label: 'wind speed 3s avg' },
];

// Helper to extract the correct value from telemetry data
function getFieldValue(rawTelemetry, fieldKey) {
  const telemetry = normalizeTelemetryRecord(rawTelemetry);
  if (!telemetry) return 'N/A';
  try {
    const data = typeof telemetry.data === 'string'
      ? JSON.parse(telemetry.data)
      : (telemetry.data || telemetry.payload || telemetry);
    const sabalController = data?.sabalController || telemetry?.sabalController || {};
    switch (fieldKey) {
      case 'messageId':
        return telemetry.messageId || telemetry.message_id || 'N/A';
      case 'sequenceNumber':
        return telemetry.sequenceNumber ?? telemetry.sequence_number ?? 'N/A';
      case 'controllerTimestamp':
        return telemetry.controllerTimestamp || telemetry.timestamp || 'N/A';
      case 'systemStateText':
        return sabalController?.systemInfo?.systemStateText || 'N/A';
      case 'canopyStateText':
        {
          const rawText = sabalController?.systemInfo?.canopyStateText;
          if (typeof rawText === 'string' && rawText.trim() !== '') return rawText;

          const state = sabalController?.systemInfo?.canopyState;
          const stateNum = (typeof state === 'number') ? state : Number(state);
          if (Number.isFinite(stateNum)) {
            if (stateNum === 13) return 'CanopyFlatW';
            if (stateNum === 14) return 'CanopyPackedW';
          }
          return 'N/A';
        }
      case 'errorCount':
        return sabalController?.errorLog?.errorCount ?? 'N/A';
      case 'windSpeed3sAvg':
        return sabalController?.['windData-ms']?.['speed 3s-m'] ?? 'N/A';
      default:
        return 'N/A';
    }
  } catch (e) {
    return 'N/A';
  }
}

const FleetTelemetryTable = ({ selectedCanopies, telemetryData, canopyNames = {} }) => {
  if (!selectedCanopies || selectedCanopies.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="body1" color="textSecondary">
          Select up to 3 canopies to view telemetry data
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer component={Paper} sx={{ maxWidth: '100%', overflowX: 'auto' }}>
      <Table size="small" sx={{ minWidth: 400 }}>
        <TableHead>
          <TableRow>
            <TableCell />
            {selectedCanopies.map((canopyId) => (
              <TableCell key={canopyId} align="center" sx={{ fontWeight: 'bold', fontFamily: 'monospace' }}>
                {canopyNames[canopyId] || canopyId}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {FIELD_LABELS.map(({ key, label }) => (
            <TableRow key={key}>
              <TableCell component="th" scope="row" sx={{ fontWeight: 'bold', fontFamily: 'monospace' }}>
                {label}
              </TableCell>
              {selectedCanopies.map((canopyId) => (
                <TableCell key={canopyId} align="center" sx={{ fontFamily: 'monospace' }}>
                  {getFieldValue(telemetryData[canopyId], key)}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FleetTelemetryTable; 